import { render, staticRenderFns } from "./edit-mobile-dialog.vue?vue&type=template&id=cb896600"
import script from "./edit-mobile-dialog.vue?vue&type=script&lang=js"
export * from "./edit-mobile-dialog.vue?vue&type=script&lang=js"
import style0 from "./edit-mobile-dialog.vue?vue&type=style&index=0&id=cb896600&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports